import React from 'react'
import { ReactComponent as Instagram } from '../../../assets/icons/socials/Instagram.svg'
import { ReactComponent as Facebook } from '../../../assets/icons/socials/Facebook.svg'
import { ReactComponent as Tiktok } from '../../../assets/icons/socials/Tiktok.svg'
import { ReactComponent as Linkedin } from '../../../assets/icons/socials/Linkedin.svg'
import { ReactComponent as Twitter } from '../../../assets/icons/socials/Twitter.svg'
import { ReactComponent as Youtube } from '../../../assets/icons/socials/Youtube.svg'
import style from './style.module.scss'
import { socialsParams } from '../../../types'

export const Socials: React.FC<{ socials: socialsParams }> = ({ socials }) => {
    return (
        <div className={style.socialsContainer}>
            <div className={style.socials}>
                {socials?.facebook && (
                    <a target="_blank" href={socials.facebook} rel="noopener noreferrer">
                        <Facebook />
                    </a>
                )}
                {socials?.instagram && (
                    <a target="_blank" href={socials.instagram} rel="noopener noreferrer">
                        <Instagram />
                    </a>
                )}

                {socials?.twitter && (
                    <a target="_blank" href={socials.twitter} rel="noopener noreferrer">
                        <Twitter />
                    </a>
                )}

                {socials?.youtube && (
                    <a target="_blank" href={socials.youtube} rel="noopener noreferrer">
                        <Youtube />
                    </a>
                )}
                {socials?.linkedin && (
                    <a target="_blank" href={socials.linkedin} rel="noopener noreferrer">
                        <Linkedin />
                    </a>
                )}
                {socials?.tiktok && (
                    <a target="_blank" href={socials.tiktok} rel="noopener noreferrer">
                        <Tiktok />
                    </a>
                )}
            </div>
        </div>
    )
}
